import { GET_GROUPS_PHASE, GET_MUNDIAL_BRACKETS } from './../types/matches.types';

const initState = {
  brackets: [],
};

export default (state = initState, action) => {
  switch (action.type) {
    case GET_MUNDIAL_BRACKETS:
      return {
        ...state,
        brackets: action.payload
      };

    default:
      return state;
  }
};
